import { checkConsent, consentCategories } from 'utils/cookies';

import {
  sentryClient,
  sentryKey,
  sentryProject,
  version,
  sentryRegex,
} from 'utils/settings';

const sentryEnabled = (): boolean =>
  Boolean(
    window.ikea.sentry &&
      sentryKey &&
      sentryProject &&
      sentryClient &&
      version &&
      checkConsent(consentCategories.performanceCookies)
  );

const release = `igift-agent@${version}`;

export const sentryInit = () => {
  if (sentryEnabled()) {
    window.ikea.sentry.register(
      sentryProject,
      sentryKey,
      sentryClient,
      release,
      1, // Log 100% of errors for now
      [sentryRegex]
    );
  } else {
    console.warn('[igift] Sentry is not active');
  }
};

export const reportError = (
  err: Error | string,
  extra: Record<string, string | number>
) => {
  if (sentryEnabled()) {
    window.ikea.sentry.store(
      err,
      sentryProject,
      sentryKey,
      sentryClient,
      release,
      1,
      extra
    );
  } else {
    console.error('[igift]', typeof err === 'string' ? err : err.message);
  }
};
